import mockLogoString from '../../utils/mock-logo-string.mjs';

export default {

    'guide.name': 'Dialogue Theme Runner',

    /**
     * ============================
     * GENERAL
     * ============================
     */
    'nav.prev': 'Go Back',
    'nav.next': 'Next',

    'contactMeForm.formInput.firstName': 'First Name:',
    'formInput.firstName.placeholder': 'Enter first name',
    'contactMeForm.formInput.lastName': 'Last Name:',
    'formInput.lastName.placeholder': 'Enter last name',
    'contactMeForm.formInput.email': 'Email:',
    'formInput.email.placeholder': 'hello@ignitesales.com',
    'contactMeForm.formInput.phone': 'Phone Number:',
    'formInput.phone.placeholder': '(254) 548-1550',

    'branchMenu.employeeInfoHeader': 'Employee Details',
    'branchMenu.logout': 'Logout',

    'error.title': 'Errors',
    'error.question.required': 'Must be answered',
    'error.question.between': 'Value must be between {0} and {1}',
    'error.questionGroup.required': 'You must answer a question',
    'error.questionGroup.between': 'Total value must be between {0} and {1}',
    'error.questionGroup.equal': 'Total value must equal to {0}',

    'landing.title': 'Welcome To Ignite Dialogue',
    'landing.message': "Ready to find the best products for your financial needs? Let's get started on finding the perfect account for you.",
    'landing.readyToStart': "Let's Go",
    'landing.button': "Let's Go",

    'loadingPage': 'Loading...',

    'logo': mockLogoString,

    'summary.subtitle': 'Congratulations, we were able to find your matching products.',
    'summary.title': 'Product Recommendations',
    'summary.schedule': 'Schedule an Appointment',
    'summary.subtext': 'Review your products below. Click the "Finish Up" button to save your results and complete the process.',
    'summary.completeBtn': 'Finish Up',
    'summary.previousPageBtn': 'Return to Conversation',

    'socialActionBar.title': 'Share',
    'socialActionBar.textMessage': 'SMS',
    'socialActionBar.email': 'Email',
    'socialActionBar.print': 'Print',

    'pleaseSelect' : 'Please Select',

    'product.applyBtn': 'Apply',
    'product.enrollBtn': 'Enroll',
    'product.openBtn': 'Open',
    'product.contactUsBtn': 'Contact Us',
    'product.makeAppointmentBtn': 'Make an Appointment',
    'product.findBranchBtn': 'Find a Branch',
    'product.seeDetails': 'Details',
    'product.seeDetails.header': 'Product Details',
    'product.features.title': 'Features:',
    'product.disclosures.title': 'Disclosures:',

    'products.disclosures.title': 'Disclosures',
    'products.features.title': 'Features',

    'answers.title': 'Your Conversation Answers',
    'answers.subtext': 'Review your questions and answers below from your conversation.',

    'footer.copyright': 'Powered By Ignite Dialogue | All Rights Reserved | {year}',

    'themeTool.subtitle': 'Ignite Dialogue',
    'themeTool.title': 'Theme Runner Tool',
    'themeTool.propertiesEditor': 'Edit Theme Properties',
    'themeRunnerColorEditor.helpText': 'Enter hex colors below and submit to change theme colors.',

    'themeRunnerColorEditor.formInput.primaryColor': 'Primary Color:',
    'themeRunnerColorEditor.formInput.primaryColor.error.required': 'Please enter a valid color in HEX format',
    'themeRunnerColorEditor.formInput.primaryColor.placeholder': '#3b3e47',

    'themeRunnerColorEditor.formInput.secondaryColor': 'Secondary Color:',
    'themeRunnerColorEditor.formInput.secondaryColor.error.required': 'Please enter a valid color in HEX format',
    'themeRunnerColorEditor.formInput.secondaryColor.placeholder': '#0c5c5c',

    'themeRunnerFdicEditor.formInput.isFdicMember': 'FDIC Member',
    'themeRunnerEhlEditor.formInput.isEhlMember': 'EHL Member',
    'themeRunnerHideActionsEditor.formInput.hideActions': 'Hide Products Actions',

    'themeRunnerColorsUpdated.success.title': 'Colors Updated',
    'themeRunnerColorsUpdated.success.message': 'Theme Runner colors have been saved',
    'themeRunnerColorsUpdated.error.title': 'Invalid Color(s)',
    'themeRunnerColorsUpdated.error.message': 'One or more of your color values is not in HEX format',

    'themeRunnerFdicUpdated.success.title': 'FDIC Updated',
    'themeRunnerFdicUpdated.success.message': 'Theme Runner FDIC has been saved',
    'themeRunnerFdicUpdated.error.title': 'Invalid FDIC',
    'themeRunnerFdicUpdated.error.message': 'Please check if client is FDIC member or not',
    
    'themeConfigurationUpdated.success.title': 'Theme Configuration Updated',
    'themeConfigurationUpdated.success.message': 'Theme Runner configurations have been saved',
    'themeConfigurationUpdated.error.title': 'Invalid Configurations',
    'themeConfigurationUpdated.error.message': 'Please check for any invalid theme configuration',

    /**
     * ============================
     * QUESTIONS
     * ============================
     */

    /**
     * ============================
     * PRODUCTS
     * ============================
     */

}
